
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from 'next-translate/useTranslation';
import { NumberSection } from '@unreserved-frontend-v2/ui/content-section/number-section/number-section';
import { SimplifiedBaseSectionProps } from '../layouts';
export const Step4Component = ({ stepNumber = '', subTitle = '' }: SimplifiedBaseSectionProps) => {
    const { t } = useTranslation('inner-pages');
    const config = {
        content: t('buying-simplified.step-4-content'),
        image: '/static/images/offer-acceptance.jpg',
        containerClassName: 'mt-5 lg:mt-[60px]',
        contentClassName: 'pt-6 lg:pt-[35px] row-start-2 lg:row-start-1 lg:col-start-6 lg:col-span-7 lg:ml-[69px]',
        imageContainerClassName: 'col-span-5 lg:col-start-1 row-start-1 hidden pt-9 lg:block',
        imageClassName: 'top-[-60px] h-[363px]',
        mobileImageContainerClassName: 'col-span-12 col-start-1 block lg:hidden'
    };
    return <NumberSection {...config} stepNumber={stepNumber} subTitle={subTitle}/>;
};
export default Step4Component;

    async function __Next_Translate__getStaticProps__1955d79d566__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//learn-more/buying-simplified/step-4-component',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1955d79d566__ as getStaticProps }
  